/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {isNotEmpty, KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomUseEffect from '../component/CustomUseEffect'
import swal from 'sweetalert'
import {CloseButton, Spinner} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getAccesses} from '../../../api/modules/order'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import axios from 'axios'
import {useDispatch, useSelector} from 'react-redux'
import {setNotifOrder, setGetNotif} from '../../../_metronic/redux/content'
import i18next from 'i18next'
import InputGroup from 'react-bootstrap/InputGroup'

const OrderSupport: React.FC = () => {
  const intl = useIntl()
  const {t} = useTranslation()

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: `${t('page detail order')} • Support`})}
      </PageTitle>
      {localStorage.getItem('cusName') === 'AGRO BOKASHINDO JAYA' && (
        <img src={toAbsoluteUrl(`/media/Merah.png`)} className='w-100 h-100' />
      )}
      {localStorage.getItem('cusName') === 'BINA SEJAHTERA' && (
        <img src={toAbsoluteUrl(`/media/Hijau.png`)} className='w-100 h-100' />
      )}
      {localStorage.getItem('cusName') === 'AFIAH' && (
        <img src={toAbsoluteUrl(`/media/Kuning.png`)} className='w-100 h-100' />
      )}
      {localStorage.getItem('cusName') === 'ABK MITRA MANDIRI' && (
        <img src={toAbsoluteUrl(`/media/Hitam.png`)} className='w-100 h-100' />
      )}
      <div className='d-flex justify-content-end mt-5 mb-10'>
        <Link to='/management/order/detail' className='me-2'>
          <Button className='btn btn-danger'>{t('order-kembali')}</Button>
        </Link>
      </div>
    </>
  )
}

export {OrderSupport}
